import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import type { EditorServiceModels } from '@editor/client-rest-api';

export const setDefaultOptionsEditor = mutatorAction(
    'setDefaultOptionsEditor',
    (id: string, categoryId: string, critiqueTypeInfo: EditorServiceModels.CritiqueTypeInfo) => {
        const defaultOptionsEditor = getStore().defaultOptionsEditor;
        defaultOptionsEditor.set(id, {
            critiqueTypeInfo: critiqueTypeInfo,
            categoryId: categoryId,
        });
    }
);
